import { Button, Typography } from "@material-ui/core";
import { SubordinatesTicketListDto, TicketListDto } from "Api/Api";
import { TicketListItem } from "Components/Dashboard/TicketListItem/TicketListItem";
import { TicketCountIcons } from "Components/Dashboard/TicketListItem/TicketCountIcons";
import { EmployeeAvatar } from "Components/Shared/EmployeeAvatar";
import * as React from "react";
import { useDispatch } from "react-redux";
import {
  closeSubordinatesTickets,
  openSubordinatesTickets,
  openSubordinateTicketsWithoutLoad,
  showMoreSubordinatesTickets,
} from "State/Tickets/TicketReducer";
import styled from "styled-components";
import { Resources, useResource } from "Translations/Resources";

const StyledItemWrapper = styled.div<{ isOpened?: boolean }>`
  ${props =>
    !props.isOpened && `border-bottom: solid 1px ${props.theme.colors.border};`}

  ${props => props.theme.breakpoints.down("xs")} {
    margin-left: ${props => props.theme.spacing(1.5)}px;
    padding-right: ${props => props.theme.spacing(1)}px;
  }
`;
const StyledItemsWrapper = styled.div`
  margin-left: ${props => props.theme.spacing(4)}px;
  margin-bottom: ${props => props.theme.spacing(2)}px;

  ${props => props.theme.breakpoints.down("xs")} {
    margin-left: -${props => props.theme.spacing(1.5)}px;
    margin-right: -${props => props.theme.spacing(1)}px;
  }
`;

const StyledEmployee = styled.div`
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding-bottom: 4px;
  margin-top: ${props => props.theme.spacing(1)}px;
`;

const StyledTitle = styled(Typography)`
  margin-bottom: ${props => props.theme.spacing(3)}px;

  ${props => props.theme.breakpoints.down("xs")} {
    margin-left: ${props => props.theme.spacing(1.3)}px;
  }
`;

const LoadMoreButtonWrapper = styled.div`
  width: 100%;
  padding: 10px;
  text-align: center;
`;

type SubordinateTicketListProps = {
  subordinates: SubordinateTicketItemProps[];
};

export type SubordinateTicketItemProps = {
  isOpened?: boolean;
  isLoading?: boolean;
  isLoaded: boolean;
  tickets?: TicketListDto[];
  isDisplayed: boolean;
  index: number;
} & SubordinatesTicketListDto;

const SubordinateTicketListItem: React.FunctionComponent<SubordinateTicketItemProps> = item => {
  const dispatch = useDispatch();

  const toggleTickets = (ticket: SubordinateTicketItemProps) => {
    if (ticket.isOpened) {
      dispatch(closeSubordinatesTickets(ticket.employeeID));
    } else if (ticket.isLoaded) {
      dispatch(openSubordinateTicketsWithoutLoad(ticket.employeeID));
    } else {
      dispatch(openSubordinatesTickets.request(ticket.employeeID));
    }
  };

  return (
    <StyledItemWrapper isOpened={item.isOpened}>
      <StyledEmployee onClick={_ => toggleTickets(item)}>
        <div>
          <EmployeeAvatar
            firstName={item.firstName}
            lastName={item.lastName}
            isTheBoss={false}
            size={"24px"}
            fontSize={"10px"}
            imgUrl={item.imgUrl}
          />
        </div>
        <Typography>
          {item.firstName} {item.lastName}
        </Typography>
        <TicketCountIcons
          ticketsAfterDueDateCount={item.ticketsAfterDueDateCount}
          ticketsCount={item.ticketsCount}
        ></TicketCountIcons>
      </StyledEmployee>

      {item.isOpened && item.isLoaded && (
        <StyledItemsWrapper>
          {item.tickets &&
            item.tickets.map(e => (
              <TicketListItem
                key={e.ticketID}
                item={e}
                hideActionIcons
                onResolveClick={_ => {}}
                onCancelClick={_ => {}}
              />
            ))}
        </StyledItemsWrapper>
      )}
    </StyledItemWrapper>
  );
};

export const SubordinatesTicketList: React.FunctionComponent<SubordinateTicketListProps> = props => {
  const { t } = useResource();
  const dispatch = useDispatch();

  const onLoadMore = () => {
    dispatch(showMoreSubordinatesTickets());
  };

  return (
    <>
      <div>
        <StyledTitle variant={"h4"}>
          {t(Resources.Dashboard.Tickets.Subordinates.Title)}
        </StyledTitle>
      </div>
      <div>
        {props.subordinates &&
          props.subordinates
            .filter(e => e.isDisplayed)
            .map(item => (
              <SubordinateTicketListItem key={item.employeeID} {...item} />
            ))}
      </div>
      {props.subordinates.filter(e => !e.isDisplayed).length > 0 && (
        <LoadMoreButtonWrapper>
          <Button
            color="primary"
            onClick={e => {
              onLoadMore();
            }}
          >
            Zobrazit další
          </Button>
        </LoadMoreButtonWrapper>
      )}
    </>
  );
};
